module.exports = __webpack_public_path__ + "img/telegram-logo.75082c4c.svg";